@if(loader){
    <app-loader></app-loader>
    }

    <p-card>
        <div class="">
        
            <div class="flex justify-content-between align-items-center flex-wrap w-100 position-relative">
                <div class="flex align-items-center">
                    <div>
                        <p-button label="New" class="p-button-outlined" icon="pi pi-plus-circle" size="small"
                            (onClick)="CreateSalesPerson()" pTooltip="Create Salesperson"></p-button>
            
                    </div>
                    <div class="flex align-items-center ml-3">
                        <span class="p-input-icon-left"><!--adjust search box by PraadK(10/06/24)-->
                            <i class="pi pi-search"></i>
                            <input pInputText type="text" [(ngModel)]="searchKey" [placeholder]="placeholder"
                                class=" p-inputtext-sm" (keyup.enter)="searchSales()"
                                style="height: 35px; font-size: 0.875rem; padding-left: 2rem;" />
                        </span>
                        <p-button icon="pi pi-search" (onClick)="searchSales()"
                            [style]="{'margin': '5px 5px 5px 5px', 'height': '35px', 'line-height': '50px'}" [raised]="true"
                            [size]="'small'" severity="info"></p-button>
                    </div>
            
                    <p-button *ngIf="selectedSalesperson && selectedSalesperson.length == 1" label="Edit" class="ml-2"
                        icon="pi pi-user-edit" (click)="editSalesPerson()" size="small" severity="secondary"></p-button>
                    <p-button *ngIf="selectedSalesperson && selectedSalesperson.length > 0" label="Delete" class="ml-2"
                        icon="pi pi-trash" (click)="deleteSalesPerson()" size="small" severity="danger"></p-button>
                </div>
            
                <h2 class="page-title-center">Salesperson List</h2>
            
                <div class="flex">
                    <div class="flex align-items-center">
                        <p-button icon="pi pi-refresh" size="small" (click)="refreshData()" [rounded]="true"
                            severity="info"></p-button>
                    </div>
                </div>
            </div>


            <p-table #dt1 [value]="result.salespersons" [scrollable]="true" scrollHeight="616px"
                styleClass="p-datatable-striped" responsiveLayout="scroll" class="w-full m-5" styleClass="p-datatable-sm "
                [paginator]="true" [rows]="10" [globalFilterFields]="['salespersonCode','salespersonName','mobile','email','address.state']"
                (onPage)="loadsalespersons($event)" [(selection)]="selectedSalesperson"
                currentPageReportTemplate="Showing {first} to {last} of {totalRecords} entries"
                [rowsPerPageOptions]="[10 ,15, 20]" [rowHover]="true" [selectionPageOnly]="true">
                <ng-template pTemplate="header">
                  <tr>
                      <th style="width: 4rem">
                          <p-tableHeaderCheckbox></p-tableHeaderCheckbox>
                      </th>
                      <!-- <th>Image</th> -->
                      <th>Salesperson Code</th>
                      <th>Salesperson Name</th>
                      <th>Mobile</th>
                      <th>Email</th>
                      <th>State</th>
                  </tr>
              </ng-template>
              <ng-template pTemplate="body" let-sales>
                  <tr>
                      <td>
                          <p-tableCheckbox [value]="sales"></p-tableCheckbox>
                      </td>
                      <!-- <td>
                          <p-image
                              [src]="sales.salespersonImage"
                              [alt]="sales.salespersonImage ? 'Salesperson Image' : 'No Image Available'"
                              width="30"
                              [preview]="true">
                          </p-image>
                      </td> -->
                      <td class="text-blue-500 underline" style="cursor: pointer;"
                          (click)="editSalesPerson(sales.salespersonId)">
                          {{sales?.salespersonCode}}
                      </td>
                      <td>{{sales?.salespersonName}}</td>
                      <td>{{sales?.mobile}}</td>
                      <td>{{sales?.email}}</td>
                      <td>{{sales.address?.state}}</td>
                  </tr>
              </ng-template>
              <ng-template pTemplate="emptymessage">
                  <tr>
                      <td colspan="8">No Records found.</td>
                  </tr>
              </ng-template>
                <ng-template pTemplate="emptymessage">
                    <tr>
                        <td colspan="8">No Records found.</td>
                    </tr>
                </ng-template>
            </p-table>
        </div>
    </p-card>

    <p-toast></p-toast>
    <p-confirmDialog></p-confirmDialog>
